import React from "react";
import { Card, CardContent } from "@mui/material";
import { Typography, Box, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HandicapRankingData } from '../../../services/hipodromo'; // Asumiendo que la interfaz está en hipodromo.ts
import { getColors } from '../../../componetes/color_racers'; // Importa la función getColors

// Interfaz para las props del componente
interface HandicapRankingProps {
    ranking: HandicapRankingData[]; // Recibe el ranking como prop
}

const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(2),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
}));

// El componente ahora es un Functional Component que recibe props
const HandicapRanking: React.FC<HandicapRankingProps> = ({ ranking }) => { // Recibe 'ranking' de las props

  // Si no hay ranking, muestra un mensaje
  if (!ranking || ranking.length === 0) {
    return <Typography>No hay datos de ranking disponibles.</Typography>;
  }

  return (
    <Container maxWidth="sm" sx={{ paddingY: 2 }}>
      {/* Usamos la prop 'ranking' para mapear */}
      {ranking.map((item, index) => {
        // Obtén los colores para la inscripción actual
        const { color: backgroundColor, textColor } = getColors(item.inscripcion_numero);

        return (
          <StyledCard key={item.ejemplar_id}>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" alignItems="center"> {/* Agregado Box para alinear inscripción y nombre */}
                  {/* Aplica los estilos al número de inscripción */}
                  <Typography
                    variant="body2"
                    component="span" // Usar span para que sea inline
                    sx={{
                      backgroundColor: backgroundColor,
                      color: textColor,
                      padding: '2px 6px', // Añade algo de padding
                      borderRadius: '4px', // Bordes redondeados
                      marginRight: 1, // Espacio a la derecha
                      fontWeight: 'bold', // Opcional: hacer el número más visible
                      minWidth: '24px', // Asegura un ancho mínimo
                      textAlign: 'center', // Centra el texto
                    }}
                  >
                    {item.inscripcion_numero}
                  </Typography>
                  <Typography variant="body1">#{index + 1} - {item.ejemplar_name}</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <Typography variant="body2" color="primary" sx={{ fontWeight: 'bold' }}>
                    {item.ranking_score.toFixed(4)} pts
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </StyledCard>
        );
      })}
    </Container>
  );
};

// Renombramos el export para que coincida con el nombre del componente
export default HandicapRanking;